import {
  Antrag,
  EinreichungComponentType,
  EinreichungStep,
  EinreichungStepResultType,
  UploadComponentBase,
} from '@ebeihilfe/einreichung-old';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Deferred, DeviceOrigin, EinreichungComponents } from '@ebeihilfe/core';

@Component({
  selector: 'portal-einreichung-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadComponent extends UploadComponentBase implements EinreichungComponentType<UploadComponent>, OnInit {
  public component = UploadComponent;
  public name = EinreichungComponents.Upload;
  public prio = EinreichungStep.UPLOADING + 1;

  public handle(
    antrag: Antrag,
    instance: UploadComponent,
    work: Deferred<EinreichungStepResultType>,
  ): Promise<EinreichungStepResultType> {
    instance.antrag = antrag;
    instance.work = work;
    return instance.work;
  }

  public ngOnInit(): void {
    this.uploadAntrag(DeviceOrigin.Portal);
  }

  public startUpload(): void {
    this.uploadAntrag(DeviceOrigin.Portal);
  }
}
